import {
  CREATE_PLACE,
  CREATE_PLACE_FAILED,
  CREATE_PLACE_SUCCESS,
  DELETE_PLACE,
  DELETE_PLACE_FAILED,
  DELETE_PLACE_SUCCESS,
  GET_COMPLETED_SURVEYS,
  GET_COMPLETED_SURVEYS_FAILED,
  GET_COMPLETED_SURVEYS_SUCCESS,
  GET_PLACES,
  GET_PLACES_FAILED,
  GET_PLACES_SUCCESS,
  GET_PLACE_DATA,
  GET_PLACE_DATA_FAILED,
  GET_PLACE_DATA_SUCCESS,
  GET_PLACE_SURVEY_REPLIES,
  GET_PLACE_SURVEY_REPLIES_FAILED,
  GET_PLACE_SURVEY_REPLIES_SUCCESS,
  HIDE_CONFIRM_DELETE_MODAL,
  OPEN_CONFIRM_DELETE_MODAL,
  RESET_SURVEYS_DATA,
  RESET_PLACE_DATA,
  UPDATE_PLACE,
  UPDATE_PLACE_FAILED,
  UPDATE_PLACE_SUCCESS,
  SHOW_BULK_UPLOAD_MODAL,
  HIDE_BULK_UPLOAD_MODAL,
  UPLOAD_BULK_PLACES,
  UPLOAD_BULK_PLACES_SUCCESS,
  UPLOAD_BULK_PLACES_FAILED,
  SET_BULK_UPLOAD_FLAG,
  GET_PLACES_WITH_CHAPTERS,
  GET_PLACES_WITH_CHAPTERS_SUCCESS,
  GET_PLACES_WITH_CHAPTERS_FAILED,
  GET_CHAPTERS,
  GET_CHAPTERS_SUCCESS,
  GET_CHAPTERS_FAILED,
  GET_PLACES_REPORTS,
  GET_PLACES_REPORTS_SUCCESS,
  GET_PLACES_REPORTS_FAILED,
  GET_PLACES_SUMMARY_REPORTS,
  GET_PLACES_SUMMARY_REPORTS_SUCCESS,
  GET_PLACES_SUMMARY_REPORTS_FAILED,
} from "./actionTypes"

export const getPlaces = params => ({
  type: GET_PLACES,
  payload: params,
})

export const getPlacesSuccess = response => ({
  type: GET_PLACES_SUCCESS,
  payload: response,
})

export const getPlacesFailed = error => ({
  type: GET_PLACES_FAILED,
  payload: error,
})

export const getPlaceData = params => ({
  type: GET_PLACE_DATA,
  payload: params,
})

export const getPlaceDataSuccess = response => ({
  type: GET_PLACE_DATA_SUCCESS,
  payload: response,
})

export const getPlaceDataFailed = error => ({
  type: GET_PLACE_DATA_FAILED,
  payload: error,
})

export const resetPlaceData = () => ({
  type: RESET_PLACE_DATA,
  payload: {},
})

export const createPlace = params => ({
  type: CREATE_PLACE,
  payload: params,
})

export const createPlaceSuccess = response => ({
  type: CREATE_PLACE_SUCCESS,
  payload: response,
})

export const createPlaceFailed = error => ({
  type: CREATE_PLACE_FAILED,
  payload: error,
})

export const updatePlace = params => ({
  type: UPDATE_PLACE,
  payload: params,
})

export const updatePlaceSuccess = response => ({
  type: UPDATE_PLACE_SUCCESS,
  payload: response,
})

export const updatePlaceFailed = error => ({
  type: UPDATE_PLACE_FAILED,
  payload: error,
})

export const openConfirmDeleteModal = () => ({
  type: OPEN_CONFIRM_DELETE_MODAL,
  payload: {},
})

export const hideConfirmDeleteModal = () => ({
  type: HIDE_CONFIRM_DELETE_MODAL,
  payload: {},
})

export const deletePlace = params => ({
  type: DELETE_PLACE,
  payload: params,
})

export const deletePlaceSuccess = response => ({
  type: DELETE_PLACE_SUCCESS,
  payload: response,
})

export const deletePlaceFailed = error => ({
  type: DELETE_PLACE_FAILED,
  payload: error,
})

export const getCompletedSurveys = params => ({
  type: GET_COMPLETED_SURVEYS,
  payload: params,
})

export const getCompletedSurveysSuccess = response => ({
  type: GET_COMPLETED_SURVEYS_SUCCESS,
  payload: response,
})

export const getCompletedSurveysFailed = error => ({
  type: GET_COMPLETED_SURVEYS_FAILED,
  payload: error,
})

export const resetSurveysData = () => ({
  type: RESET_SURVEYS_DATA,
  payload: {},
})

export const getPlaceSurveyReplies = params => ({
  type: GET_PLACE_SURVEY_REPLIES,
  payload: params,
})

export const getPlaceSurveyRepliesSuccess = response => ({
  type: GET_PLACE_SURVEY_REPLIES_SUCCESS,
  payload: response,
})

export const getPlaceSurveyRepliesFailed = error => ({
  type: GET_PLACE_SURVEY_REPLIES_FAILED,
  payload: error,
})

export const showBulkUploadModal = () => ({
  type: SHOW_BULK_UPLOAD_MODAL,
  payload: {},
})

export const hideBulkUploadModal = () => ({
  type: HIDE_BULK_UPLOAD_MODAL,
  payload: {},
})

export const uploadBulkPlaces = params => ({
  type: UPLOAD_BULK_PLACES,
  payload: params,
})

export const uploadBulkPlacesSuccess = response => ({
  type: UPLOAD_BULK_PLACES_SUCCESS,
  payload: response,
})

export const uploadBulkPlacesFailed = error => ({
  type: UPLOAD_BULK_PLACES_FAILED,
  payload: error,
})

export const setBulkUploadFlag = value => ({
  type: SET_BULK_UPLOAD_FLAG,
  payload: value,
})

export const getPlacesWithChapters = params => ({
  type: GET_PLACES_WITH_CHAPTERS,
  payload: params,
})

export const getPlacesWithChaptersSuccess = response => ({
  type: GET_PLACES_WITH_CHAPTERS_SUCCESS,
  payload: response,
})

export const getPlacesWithChaptersFailed = error => ({
  type: GET_PLACES_WITH_CHAPTERS_FAILED,
  payload: error,
})

export const getChapters = params => ({
  type: GET_CHAPTERS,
  payload: params,
})

export const getChaptersSuccess = response => ({
  type: GET_CHAPTERS_SUCCESS,
  payload: response,
})

export const getChaptersFailed = error => ({
  type: GET_CHAPTERS_FAILED,
  payload: error,
})

export const getPlacesReports = params => ({
  type: GET_PLACES_REPORTS,
  payload: params,
})

export const getPlacesReportsSuccess = response => ({
  type: GET_PLACES_REPORTS_SUCCESS,
  payload: response,
})

export const getPlacesReportsFailed = error => ({
  type: GET_PLACES_REPORTS_FAILED,
  payload: error,
})

export const getPlacesSummaryReports = params => ({
  type: GET_PLACES_SUMMARY_REPORTS,
  payload: params,
})

export const getPlacesSummaryReportsSuccess = response => ({
  type: GET_PLACES_SUMMARY_REPORTS_SUCCESS,
  payload: response,
})

export const getPlacesSummaryReportsFailed = error => ({
  type: GET_PLACES_SUMMARY_REPORTS_FAILED,
  payload: error,
})
